<template>
  <div class="units-component">
    <loading-component v-if="downloading"></loading-component>

    <div class="model-detail" v-if="current_unit">
      <div class="model-detail__inner">
        <div class="modal-header">
          <div class="details" v-on:click="current_unit = null">
            <div class="close">
              <button v-on:click="current_unit = null">{{ closeText }}</button>
            </div>
            <div
              v-if="projectTypeId != 10"
              class="detail price"
              :class="[
                current_unit.isAvailable == 0 && current_unit.isReserved == 0
                  ? 'isSold'
                  : '',
              ]"
            >
              <span>{{ priceText }}</span>
              <div>{{ current_unit.formattedPrice }}</div>
            </div>
            <div class="detail">
              <span>{{ levelText }}</span>
              <div>{{ current_unit.floor }}</div>
            </div>
            <div class="detail">
              <span>{{ modelText }}</span>
              <div>{{ current_unit.title }}</div>
            </div>
          </div>

          <div class="btn">
            <a :href="contactPageUrl">{{ emailUsText }}</a>
            <p>
              <a :href="'tel:' + phoneText" class="phone">{{ phoneText }}</a>
            </p>
          </div>
        </div>
        <div class="plan-header" v-if="current_unit.planPdf">
          <div class="email">
            <a :href="contactPageUrl">{{ emailUsText }}</a>
            <p>
              <a :href="'tel:' + phoneText">{{ phoneText }}</a>
            </p>
          </div>

          <a
            class="video-tour-btn"
            v-if="current_unit.youtubeUrl"
            @click.prevent="current_video = current_unit.youtubeId"
            href=""
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="46"
              height="46"
              viewBox="0 0 46 46"
            >
              <g transform="translate(-471 -1121)">
                <g
                  transform="translate(471 1121)"
                  fill="none"
                  stroke="#fff"
                  stroke-width="2"
                >
                  <circle cx="23" cy="23" r="23" stroke="none" />
                  <circle cx="23" cy="23" r="22" fill="none" />
                </g>
                <path
                  d="M10,0,20,17H0Z"
                  transform="translate(505 1134) rotate(90)"
                  fill="#fff"
                />
              </g>
            </svg>
            <span>{{ videoTourTitle }}</span>
          </a>

          <div class="download-print">
            <div class="shares">
              <a
                class="resp-sharing-button__link facebook-icon icon"
                :href="
                  'https://facebook.com/sharer/sharer.php?u=' +
                  current_unit.planPdf
                "
                target="_blank"
                aria-label=""
              >
              </a>
              <a
                class="resp-sharing-button__link twitter-icon icon"
                :href="
                  'https://twitter.com/intent/tweet/?text=' +
                  unitTitle +
                  '&amp;url=' +
                  current_unit.planPdf
                "
                target="_blank"
                aria-label=""
              >
              </a>
              <a
                class="resp-sharing-button__link email-icon icon"
                :href="
                  'mailto:?subject=' +
                  unitTitle +
                  '&amp;body=' +
                  current_unit.planPdf
                "
                target="_self"
                aria-label=""
              >
              </a>
            </div>

            <a :href="current_unit.planPdf" target="_blank">{{
              downloadPdfText
            }}</a>
            <a href="" v-on:click.prevent="printPdf(current_unit.planPdf)">{{
              printText
            }}</a>
          </div>
        </div>
        <a
          class="video-tour-btn"
          v-if="current_unit.youtubeUrl"
          @click.prevent="current_video = current_unit.youtubeId"
          href=""
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="46"
            height="46"
            viewBox="0 0 46 46"
          >
            <g transform="translate(-471 -1121)">
              <g
                transform="translate(471 1121)"
                fill="none"
                stroke="#fff"
                stroke-width="2"
              >
                <circle cx="23" cy="23" r="23" stroke="none" />
                <circle cx="23" cy="23" r="22" fill="none" />
              </g>
              <path
                d="M10,0,20,17H0Z"
                transform="translate(505 1134) rotate(90)"
                fill="#fff"
              />
            </g>
          </svg>
          <span>{{ videoTourTitle }}</span>
        </a>
        <div class="plan-image">
          <div v-if="current_unit.planImages.length > 0">
            <img
              v-for="planImage in current_unit.planImages"
              :src="planImage"
            />
          </div>
          <img
            v-else-if="current_unit.planPdfThumb"
            :src="current_unit.planPdfThumb"
          />
        </div>
      </div>
    </div>

    <div
      class="video-popup"
      v-if="current_video"
      :class="{ 'is-open': current_video }"
    >
      <div class="video-close" @click.prevent="closeVideo()">
        <button>{{ closeText }}</button>
      </div>
      <div class="video-content container">
        <div class="iframe-container">
          <iframe
            id="unit-video-iframe"
            width="560"
            height="315"
            :src="
              'https://www.youtube.com/embed/' +
              current_video +
              '?enablejsapi=1&playsinline=1&rel=0'
            "
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>

    <div class="units-list">
      <div class="title">
        <h2>{{ titleText }}</h2>
      </div>
      <div class="filters" data-slideout-ignore>
        <div
          class="show-filters"
          v-if="isMobile"
          v-on:click="showFilters = !showFilters"
          :class="{ isOpen: showFilters }"
        >
          {{ showFiltersText }}
        </div>
        <transition name="fade" v-on:after-enter="refresh">
          <div v-show="showFilters" class="container">
            <p v-if="projectTypeId == 10" class="filter-label">
              {{ moveInText }}
            </p>

            <div v-if="projectTypeId == 10" class="date">
              <div class="filter month">
                <select v-model="months" v-on:change="filterChange()">
                  <option value="">{{ monthsText }}</option>
                  <option v-for="n in months_range" v-bind:value="n">
                    {{
                      new Date("2020/" + n + "/01").toLocaleString(
                        locale + "-CA",
                        { month: "long" }
                      )
                    }}
                  </option>
                </select>
              </div>

              <div class="filter">
                <select v-model="years" v-on:change="filterChange()">
                  <option value="">{{ yearsText }}</option>
                  <option v-for="n in years_range" v-bind:value="n">
                    {{ n }}
                  </option>
                </select>
              </div>
            </div>

            <div class="filter" v-if="isCommercial != 1">
              <select v-model="bedrooms" v-on:change="filterChange()">
                <option value="">{{ bedroomsText }}</option>
                <option v-for="n in bedrooms_range" v-bind:value="n">
                  {{ n }}
                </option>
              </select>
            </div>

            <div v-if="isCommercial != 1" class="filter">
              <select v-model="bathrooms" v-on:change="filterChange()">
                <option value="">{{ bathroomsText }}</option>
                <option v-for="n in bathrooms_range" v-bind:value="n">
                  {{ n }}
                </option>
              </select>
            </div>

            <div class="filter" v-if="projectTypeId != 10">
              <span>{{ areaText }}</span>
              <div class="slider-wrapper">
                <span class="range-left">{{ area_range[0] }}</span>
                <vue-slider
                  ref="areaSlider"
                  :formatter="area_format"
                  :min="min_area"
                  :max="max_area"
                  :height="1"
                  :dotSize="10"
                  :real-time="true"
                  :tooltip="false"
                  v-model="area_range"
                  v-on:callback="filterChange(true)"
                ></vue-slider>
                <span class="range-right">{{ area_range[1] }}</span>
              </div>
            </div>

            <div v-if="projectTypeId != 10" class="filter">
              <span>{{ priceText }}</span>
              <div class="slider-wrapper">
                <span class="range-left">{{
                  priceFormat(price_range[0])
                }}</span>
                <vue-slider
                  ref="priceSlider"
                  :formatter="price_format"
                  :min="min_price"
                  :max="max_price"
                  :height="1"
                  :dotSize="10"
                  :real-time="true"
                  :tooltip="false"
                  v-model="price_range"
                  v-on:callback="filterChange(true)"
                ></vue-slider>
                <span class="range-right">{{
                  priceFormat(price_range[1])
                }}</span>
              </div>
            </div>

            <div class="filter">
              <input
                type="checkbox"
                id="available-units"
                v-model="available"
                v-on:change="filterChange()"
              />
              <label for="available-units">{{ availableUnitsOnlyText }}</label>
            </div>
          </div>
        </transition>
      </div>
      <div class="container">
        <div
          class="table-head"
          :class="['nb-rows-' + nb_rows, { active: showFilters }]"
        >
          <div class="unit">{{ unitText }}</div>
          <div v-if="isCommercial != 1" class="model">{{ modelText }}</div>
          <div v-if="isCommercial != 1" class="beds">{{ bedroomsText }}</div>
          <div v-if="isCommercial != 1" class="bath">{{ bathText }}</div>
          <div class="area">
            {{ areaText }}<sup>{{ sqFtText }}</sup>
          </div>
          <div v-if="projectTypeId != 10" class="price">
            {{ priceText }}<sup v-if="isTax == 1">(+{{ taxeText }})</sup>
          </div>
          <div class="available">{{ availabilityText }}</div>
          <div class="date" v-if="availability_date && isCommercial != 1">
            {{ dateText }}
          </div>
          <div v-bind:class="{ alignRight: isCommercial == 1 }">
            {{ planText }}
          </div>
        </div>
        <div
          class="table-group"
          v-for="floor in filteredFloors"
          :key="floor.floor"
          :class="{ isHidden: !floor.show }"
        >
          <div class="floor" v-on:click.prevent="floor.show = !floor.show">
            {{ floor.floor }}
            <a class="toggle-floor" href="">{{ toggleText }}</a>
          </div>
          <div class="units" v-show="floor.show">
            <transition-group
              name="staggered-fade"
              tag="div"
              v-bind:css="false"
              v-on:before-enter="beforeEnter"
              v-on:enter="enter"
              v-on:leave="leave"
            >
              <div
                class="table-row"
                v-for="(unit, index) in floor.filteredUnits"
                :class="[
                  unit.isAvailable == 0 && unit.isReserved == 0 ? 'isSold' : '',
                  'nb-rows-' + nb_rows,
                ]"
                :key="unit.id"
                v-bind:data-index="index"
              >
                <div class="unit-label">
                  <div class="model">
                    <span>{{ unitText }}</span> {{ unit.title }}
                  </div>
                  <div v-if="projectTypeId != 10" class="price">{{ unit.formattedPrice }}</div>
                </div>
                <div class="unit-details">
                  <div v-if="isCommercial != 1" class="beds">
                    {{ unit.bedrooms }}
                  </div>
                  <div v-if="isCommercial != 1" class="bath">
                    {{ unit.bathrooms }}
                  </div>
                  <div class="area">
                    {{ unit.area }} <br /><span>{{ sqFtText }}</span>
                  </div>
                </div>

                <div class="unit detail">{{ unit.title }}</div>
                <div v-if="isCommercial != 1" class="model detail">
                  {{ unit.model }}
                </div>
                <div v-if="isCommercial != 1" class="beds detail">
                  {{ unit.bedrooms }}
                </div>
                <div v-if="isCommercial != 1" class="bath detail">
                  {{ unit.bathrooms }}
                </div>
                <div class="area detail">{{ unit.area }}</div>
                <div v-if="projectTypeId != 10" class="price detail">{{ unit.formattedPrice }}</div>
                <!--<div class="available detail"><span class="availability">{{ unit.isAvailable == 1 ? availableText : soldText }}</span><span class="reserved">{{ reservedText }}</span></div>-->
                <div class="available detail">
                  <span
                    v-if="unit.isReserved == 1"
                    class="availability-reserved"
                    >{{ reservedText }}</span
                  >
                  <span
                    v-else-if="unit.isAvailable == 1"
                    class="availability-available"
                    >{{ availableText }}</span
                  >
                  <span
                    v-else-if="unit.isAvailable == 0"
                    class="availability-sold"
                    >{{ soldText }}</span
                  >
                </div>
                <div
                  class="availability-date detail"
                  v-if="availability_date && isCommercial != 1"
                >
                  <span v-if="isImmediatelyAvailable(unit.dateAvailableFormatted)">
                    {{ immediatelyLabel }}
                  </span>
                  <span v-else>
                    {{ unit.dateAvailableFormatted }}
                  </span>
                </div>
                <div>
                  <button v-on:click="viewUnitPlan(unit)">
                    {{ viewPlanText }}
                  </button>
                </div>
              </div>
            </transition-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import vueSlider from "vue-slider-component";
import TWEEN from "@tweenjs/tween.js";
import LoadingComponent from "./Loading.vue";
import _ from "lodash";
import helpers from "../helpers";

export default {
  components: {
    vueSlider,
    LoadingComponent,
  },

  props: [
    "units",
    "planApiUrl",
    "isTax",
    "projectTypeId",
    "contactPageUrl",
    "showFiltersText",
    "closeText",
    "priceText",
    "bathroomsText",
    "levelText",
    "modelText",
    "emailUsText",
    "downloadPdfText",
    "printText",
    "areaText",
    "selectBedroomsText",
    "monthsText",
    "yearsText",
    "moveInText",
    "availableUnitsOnlyText",
    "unitText",
    "bedsText",
    "bedroomsText",
    "bathText",
    "sqFtText",
    "taxeText",
    "availableText",
    "availabilityText",
    "soldText",
    "dateText",
    "planText",
    "toggleText",
    "viewPlanText",
    "reservedText",
    "phoneText",
    "titleText",
    "unitTitle",
    "isCommercial",
    "videoTourTitle",
    "locale",
    "immediatelyLabel",
  ],

  data() {
    return {
      downloading: false,

      min_price: 0,
      max_price: 0,
      price_range: [0, 0],
      price_format: (value) => {
        return helpers.formatPrice(value);
      },

      min_area: 0,
      max_area: 0,
      area_range: [0, 0],
      area_format: (value) => {
        return value;
      },

      bedrooms: "",
      bedrooms_range: [1, 2],

      bathrooms: "",
      bathrooms_range: [1, 2],

      months: "",
      years: "",
      months_range: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      years_range: [],

      available: true,

      current_unit: null,

      current_video: null,

      player: null,

      units_cache: [],

      scrollTimeout: null,

      floors: [],

      availability_date: false,
      nb_rows: 8,

      showFilters: true,

      isMobile: false,

      currentDate: null,
    };
  },

  computed: {
    filteredFloors() {
      let floors = this.floors;
      _.each(floors, (floor) => {
        let units = this.filterUnits(floor.units);
        units = _.sortBy(units, (unit) => {
          return unit.title;
        });
        _.each(units, (unit) => {
          unit.formattedPrice = helpers.formatPrice(unit.price);
        });
        floor.filteredUnits = units;
      });
      floors = _.filter(floors, (item) => {
        return item.filteredUnits.length > 0;
      });
      return floors;
    },
    rowHeight() {
      return this.isMobile ? 240 : 84;
    },
    currentDate() {
      return new Date();
    }
  },

  watch: {
    current_unit: function () {
      if (this.current_unit) {
        document.querySelectorAll("body")[0].classList.add("has-popup");
      } else {
        document.querySelectorAll("body")[0].classList.remove("has-popup");
      }
    },
    current_video: function () {
      if (this.current_video) {
        this.$nextTick(() => {
          var videoPopup = document.querySelector(
            ".units-component .video-popup"
          );

          var onPlayerReady = function (event) {
            event.target.playVideo();
          };

          this.player = new window.YT.Player(
            videoPopup.querySelector("iframe").id,
            {
              events: {
                onReady: onPlayerReady,
              },
            }
          );
        });
      }
    },
  },

  created() {
    this.floors = _.map(
      _.groupBy(this.units, (x) => x.floor),
      (value, key) => ({ floor: key, units: value, show: false })
    );
    this.floors[0].show = true;

    this.initMobile();
    this.setAvailabilityDate();
    this.setPriceRange();
    this.setAreaRange();
    this.setBedroomsRange();
    this.setBathroomsRange();
    this.parseParameters();
    this.setYearsRange();
    this.currentDate = new Date();
  },

  mounted() {
    this.refresh();
  },

  methods: {
    filterUnits(units) {
      return _.filter(units, (unit) => {
        let price = parseInt(unit.price);
        let area = parseInt(unit.area);
        let filterResults = !(
          (this.available && parseInt(unit.isAvailable) === 0) ||
          price < parseInt(this.price_range[0]) ||
          price > parseInt(this.price_range[1]) ||
          area < parseInt(this.area_range[0]) ||
          area > parseInt(this.area_range[1]) ||
          (this.bedrooms !== "" && unit.bedrooms != this.bedrooms) ||
          (this.bathrooms !== "" && unit.bathrooms != this.bathrooms)
        );

        if (this.projectTypeId === "10") {
          const unitAvailabilityDate = new Date(unit.dateAvailableFormatted);

          if (this.months !== "" || this.years !== "") {
            let month = this.months;
            let year = this.years;

            if (this.months === "") month = new Date().getMonth();
            if (this.years === "") year = new Date().getFullYear();

            let moveInDate = new Date(year + "/" + month + "/01");

            return (
              filterResults &&
              unitAvailabilityDate.getTime() <= moveInDate.getTime()
            );
          } else {
            return filterResults;
          }
        } else {
          return filterResults;
        }
      });
    },

    setAvailabilityDate() {
      if (
        _.some(this.units, (unit) => {
          return !!unit.dateAvailable;
        })
      ) {
        this.availability_date = true;
        this.nb_rows = this.isCommercial == 1 ? 5 : 9;
      }
    },

    setPriceRange() {
      var minPrice = this.getUnitMinValue(this.units, "price");
      var maxPrice = this.getUnitMaxValue(this.units, "price");
      var roundNb = helpers.getPowerOfTen(minPrice) / 10;
      this.min_price = Math.floor(minPrice * (1 / roundNb)) * roundNb;
      this.max_price = Math.ceil(maxPrice * (1 / roundNb)) * roundNb;
      this.price_range = [this.min_price, this.max_price];
    },

    setAreaRange() {
      var minArea = this.getUnitMinValue(this.units, "area");
      var maxArea = this.getUnitMaxValue(this.units, "area");
      var roundNb = helpers.getPowerOfTen(minArea) / 10;
      this.min_area = Math.floor(minArea * (1 / roundNb)) * roundNb;
      this.max_area = Math.ceil(maxArea * (1 / roundNb)) * roundNb;
      this.area_range = [this.min_area, this.max_area];
    },

    setBedroomsRange() {
      this.bedrooms_range = _.sortBy(
        _.uniq(
          _.flatMap(this.units, (unit) => {
            return unit.bedrooms.trim();
          })
        )
      );
    },

    setBathroomsRange() {
      this.bathrooms_range = _.sortBy(
        _.uniq(
          _.flatMap(this.units, (unit) => {
            return unit.bathrooms.trim();
          })
        )
      );
    },

    setYearsRange() {
      for (let i = 0; i <= 5; i++) {
        let date = new Date().getFullYear() + i;
        this.years_range.push(date);
      }
    },

    getUnitMinValue(units, prop) {
      return parseInt(
        _.minBy(units, (unit) => {
          return parseInt(unit[prop]);
        })[prop]
      );
    },

    getUnitMaxValue(units, prop) {
      return parseInt(
        _.maxBy(units, (unit) => {
          return parseInt(unit[prop]);
        })[prop]
      );
    },

    viewUnitPlan(unit) {
      if (this.units_cache[unit.id]) {
        this.current_unit = this.units_cache[unit.id];
      } else {
        if (unit.planPdf && unit.planImages.length === 0) {
          this.downloading = true;
          this.$http
            .get(
              this.planApiUrl + "?planPdf=" + encodeURIComponent(unit.planPdf)
            )
            .then(
              (response) => {
                this.downloading = false;

                let planPdfThumb = response.body["planPdfThumb"];
                this.current_unit = unit;
                this.current_unit.planPdfThumb = planPdfThumb;
                this.units_cache[unit.id] = unit;
              },
              (response) => {
                // error callback
              }
            );
        } else {
          this.current_unit = unit;
          this.units_cache[unit.id] = unit;
        }
      }
    },

    printPdf(pdf) {
      helpers.printPdf(pdf);
    },

    parseParameters() {
      var available = helpers.getURLParameter("available");
      if (available) {
        this.available = available === "true";
      }

      var minPrice = helpers.getURLParameter("min_price");
      var maxPrice = helpers.getURLParameter("max_price");
      if (minPrice && maxPrice) {
        if (minPrice < this.min_price) minPrice = this.min_price;
        if (maxPrice > this.max_price) maxPrice = this.max_price;
        this.price_range = [minPrice, maxPrice];
      }

      var bedrooms = helpers.getURLParameter("bedrooms");
      if (bedrooms) {
        this.bedrooms = bedrooms;
      }

      var bathrooms = helpers.getURLParameter("bathrooms");
      if (bathrooms) {
        this.bathrooms = bathrooms;
      }

      var years = helpers.getURLParameter("move_in_years");
      if (years) {
        this.years = years;
      }

      var months = helpers.getURLParameter("months");
      if (months) {
        this.years = months;
      }
    },

    refresh() {
      this.$refs["areaSlider"].refresh();
      this.$refs["priceSlider"].refresh();
    },

    priceFormat(value) {
      return helpers.formatPrice(value);
    },

    filterChange(timeout = false) {
      if (timeout) {
        if (this.scrollTimeout) {
          clearTimeout(this.scrollTimeout);
          this.scrollTimeout = null;
        }
        this.scrollTimeout = setTimeout(() => {
          this.scrollToFilters();
        }, 200);
      } else {
        this.scrollToFilters();
      }
    },

    scrollToFilters() {
      var top =
        window.pageYOffset +
        document.querySelector(".units-list").getBoundingClientRect().top -
        document.querySelector(".main-nav").scrollHeight;
      helpers.scrollToTop(top, 600, 0);
    },

    beforeEnter(el) {
      el.style.opacity = 0;
      el.style.height = 0;
    },

    enter(el, done) {
      var delay = el.dataset.index * 50;
      setTimeout(() => {
        this.animateRow(
          el,
          { opacity: 0, height: 0 },
          { opacity: 1, height: this.rowHeight },
          done
        );
      }, delay);
    },

    leave(el, done) {
      var delay = el.dataset.index * 50;
      setTimeout(() => {
        this.animateRow(
          el,
          { opacity: 1, height: this.rowHeight },
          { opacity: 0, height: 0 },
          done
        );
      }, delay);
    },

    animateRow(el, from, to, callback) {
      function animate() {
        if (TWEEN.update()) {
          requestAnimationFrame(animate);
        }
      }
      new TWEEN.Tween(from)
        .easing(TWEEN.Easing.Quadratic.Out)
        .to(to, 600)
        .onUpdate((object) => {
          el.style.setProperty("opacity", object.opacity);
          el.style.setProperty("height", object.height + "px");
        })
        .onComplete(() => {
          callback();
        })
        .start();
      animate();
    },

    initMobile() {
      if (window.matchMedia("(max-width: 767px)").matches) {
        this.isMobile = true;
        this.showFilters = false;
      }
    },

    closeVideo() {
      if (this.player) {
        this.player.stopVideo();
        this.player = null;
      }
      this.current_video = null;
    },

    isImmediatelyAvailable(unitDate) {
      return this.currentDate >= new Date(unitDate);
    },
  },
};
</script>
